import styled, { css } from 'react-emotion';
import { withTheme } from 'emotion-theming';

export const ForgotPasswordInnerText = withTheme(styled.div`
  ${({ theme: { color } }) => `
  width: 394px;
  font-size: 18px;
  color: ${color.black3};
  line-height: 20px;
  padding: 10px 0 0 0;
  
  @media (max-width: 767px) {
    width: 339px;
    font-size: 14px;
    padding: 5px 0 0 0;
  }

  `};
`);

export const ForgotPasswordHeading = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black2};
    font-size: 32px;
    margin-bottom: 0px;
    text-transform: inherit;
    text-align: center;
    width: 394px;
    font-weight: bold;
    
    @media (max-width: 767px) {
      width: 339px;
      font-size: 24px;
      text-align: left;
      padding-top: 75px;
    }
    
  `};
`);

export const ForgotPasswordSearchInputWrapper = styled.div`
  width: 394px;
  padding: 54px 0 0 0;
  @media (max-width: 767px) {
    width: 339px;
    padding: 45px 0 0 0;
  }
`;

export const ForgotPasswordSquareBorderButtonWrapper = styled.div`
  width: 394px;
  padding: 55px 0 0 0;
  @media (max-width: 767px) {
    width: 339px;
    padding: 50px 0 0 0;
  }
`;

export const buttonClass = css`
  width: 394px;
  borderradius: 4px;
  height: 44px;
  @media (max-width: 767px) {
    width: 339px;
    position: fixed;
    bottom: 18px;
  }
`;

export const FixMargin = styled.div`
  @media (max-width: 767px) {
    height: 60px;
  }
`;

export const SuccessMessage = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black2};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 20px;
    padding: 25px 0 0 0;
    @media (max-width: 767px) {
      padding: 70px 0 0 0;
    }
  `};
`);

export const SuccessCircle = withTheme(styled.div`
  ${({ theme: { color } }) => `
    background: ${color.accent};
    border-radius: 50%;
    height: 29px;
    width: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    svg {
      fill: ${color.white};
    }
    @media (max-width: 767px) {
      padding: 70px 0 0 0;
    }
  `};
`);
